import { Users, FolderCheck, Star, CalendarClock } from "lucide-react";
import { computeStats } from "@/lib/stats";
import { Reveal } from "@/components/common/Reveal";

export const Stats = ({ dark = false }) => {
  const s = computeStats();
  const items = [
    { icon: Users, value: `${s.clients}+`, label: "Happy clients", id: "clients" },
    { icon: FolderCheck, value: `${s.projects}+`, label: "Projects delivered", id: "projects" },
    { icon: Star, value: `${s.rating}+`, label: "Average rating", id: "rating" },
    { icon: CalendarClock, value: `${s.years}+`, label: "Years of experience", id: "years" },
  ];
  return (
    <section className={`${dark ? "on-dark bg-ink text-white" : "border-y border-line bg-white"} py-10 sm:py-12`} aria-label="Rigorfield in numbers" data-testid="stats-band">
      <div className="container-x">
        <ul className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-line bg-line lg:grid-cols-4">
          {items.map(({ icon: I, value, label, id }, i) => (
            <Reveal as="li" key={id} delay={i * 0.05} className="flex h-full min-h-[132px] flex-col items-center justify-center gap-2 bg-white px-4 py-6 text-center" data-testid={`stat-${id}`}>
              <I className="h-6 w-6 text-teal" aria-hidden />
              <span className="font-display text-3xl font-extrabold tabular-nums text-ink sm:text-4xl">{value}</span>
              <span className="text-sm font-semibold text-slate-600">{label}</span>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
